import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  user,
  domain,
  board,
}) => new Promise((resolve) => {
  nsApi.get({
    object: 'dashboard',
    action: 'favorite',
    dashboard_id: board.id,
    domain,
    user,
  }).then(() => {
    resolve(true);
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
